import ActionBtn from "components/buttons/ActionBtn";
import { RefreshButton } from "components/buttons/RefreshButton";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import { t } from "i18next";
import { GuideButton } from "modals/guides/GuideButton";
import { useGuideModal } from "modals/guides/useGuideModal";
import React from "react";

type Props = {
  options: { label: string; value: string }[];
  createModal?: () => void;
  selectAction?: (v: string) => void;
  isDisabled?: boolean;
  isCreateAllowed?: boolean;
  refresh?: () => void;
  isRefreshRequested?: boolean;
};

export const CmsPartnersHeader: React.FC<Props> = ({
  options,
  createModal = () => {},
  selectAction = () => {},
  isDisabled = false,
  isCreateAllowed,
  refresh = () => { },
  isRefreshRequested
}) => {
const { openGuide } = useGuideModal();

  return (
    <div className="page-list-header">
      <div className="page-list-header--box">
        <ActionBtn
          txt={t("addNotification")}
          handleClick={() => {
            if (createModal) {
              createModal();
            }
          }}
        />
      </div>
      <div className="page-list-header--box page-list-header--box--right">
        <RefreshButton
          position="right"
          disabled={isRefreshRequested}
          isLoading={isRefreshRequested}
          onClick={() => refresh()}
        />
      </div>
      <div className="page-list-header--box page-list-header--box-actions">
        <GuideButton onClick={() => openGuide("cms")} />
        <DefaultDropdown
          onSelect={(e) => {
            if (selectAction) {
              selectAction(e as string);
            }
          }}
          placeholder={t("chooseAction")}
          options={options}
          isSmall
          disabled={isDisabled}
        />
      </div>
    </div>
  );
};
